const removeAlphabeticChars = (locationCode) => locationCode?.replace(/\D/g, '')

export default removeAlphabeticChars
